const UrlRegexWithOptionalProtocol = /^(?:http(s)?:\/\/)?([a-z0-9-_]+\.)*[a-z0-9-_]+\.[a-z]{2,63}(\/[^\s]*\/?)*$/i;

export const websiteSchema = {
  name: 'Website schema',
  type: 'object',
  properties: {
    website: {
      required: true,
      type: 'string',
      pattern: UrlRegexWithOptionalProtocol,
      maxLength: 253,
    },
  },
};

export const businessNameSchema = {
  name: 'Business name schema',
  type: 'object',
  properties: {
    business: {
      type: 'string',
      maxLength: 40,
      minLength: 3,
      required: true,
    },
  },
};
